import React, { useContext, useEffect, useState, useRef } from 'react'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RadioBox from '@/product/components/atoms/RadioBox/index'
import { GreenRadio } from '@/product/components/atoms/RadioBox'
import ProductContext from '@/product/context/product/productContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import CheckBox from '@/product/components/atoms/CheckBox/index'
import { mapData } from '@/product/common/components'
import { capitalize } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { initialSearchFunction } from '@/product/components/species/dynamic/common/FieldFunction'
import { useLocation, useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import { Button } from '@material-ui/core'
import Slider from '@material-ui/core/Slider'
import { FlashOffOutlined, FlashOnOutlined, SettingsPhoneTwoTone } from '@material-ui/icons'
import { dateFormatMonthDate } from '@/product/common/components'
import { useTranslation } from 'react-i18next'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#fff',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 50,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails)

const FilterPanel = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const productCommonContext = useContext(ProductCommonContext)
    const dynamicContext = useContext(DynamicContext)
    const { t } = useTranslation()

    const productContext = useContext(ProductContext)
    const { active_sorts, getAllActiveSorts } = productContext
    const { getAllDynamicArray, dynamicValue } = dynamicContext
    const { allCountries, allStates, allCities } = productCommonContext
    const { allCategory, allCondition, allLocations, alldata_all_dropdown } = customCommonContext

    const [expanded, setExpanded] = React.useState(
        props.defaultPanel ? props.defaultPanel : 'panel0',
    )
    const [show, setShow] = React.useState(false)
    const [arrayValue, setArrayValue] = React.useState([])
    const [mapDataValue, setMapDataValue] = React.useState([])
    const [reload, setReload] = React.useState(false)
    const [valueLoaded, setValueLoaded] = useState(false)
    const [showBtn, setShowBtn] = useState(false)

    let formik = props.formik

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleChange2 = (event, newValue) => {
        setKilometerRange(newValue)
        props.handleKelometer(newValue)
    }
    const handleChange3 = (event, newValue) => {
        setPowerRange(newValue)
        props.handlePower(newValue)
    }
    const handleChangeYear = (event, newValue) => {
        setYearRange(newValue)
        props.handleYear(newValue)
    }

    const handleChange = (panel) => (event, newExpanded) => {
        if (panel === expanded) {
            setExpanded(false)
        } else setExpanded(panel)
    }
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [condition, setCondition] = useState([])
    const [locationData, setLocationData] = useState([])

    const price = [
        {
            value: 'p.date_closed,ASC',
            show: 'Ending Soonest',
        },
        {
            value: 'p.date_closed,DESC',
            show: 'Ending Latest',
        },
        {
            value: 'it.asin_price,ASC',
            show: 'Retail Value Low to High',
        },
        {
            value: 'it.asin_price,DESC',
            show: 'Retail Value High to Low',
        },
        {
            value: '15',
            show: 'Offer Price Low to High',
        },
        {
            value: '14',
            show: 'Offer Price High to Low',
        },
        {
            value: '6',
            show: 'Buy It Now Price Low to High',
        },
        {
            value: '7',
            show: 'Buy It Now Price High to Low',
        },
        {
            value: '20',
            show: `Today's Steal`,
        },
    ]

    const [category, setCategory] = useState([])

    useEffect(() => {
        if (props.filtersLoaded) {
            setValueLoaded(true)
        }
        if (props.category) {
            setCategory(props.category)
        }
        if (props.condition) {
            setCondition(props.condition)
        }
        if (props.locationData) {
            setLocationData(props.locationData)
        }
    }, [props.filtersLoaded, props.category, props.condition, props.locationData])

    const filterSections = [
        {
            title: 'Price/Time',
            type: 'select',
            options: price,
            name: 'orderby',
            onChange: (event, value) => {
                props.handleFormikChange(`orderby`, value)
            },
        },
        {
            name: 'location',
            type: 'select',
            title: 'Location',
            search_type: 'checkbox',
            filter: true,
            item: locationData,
            onChange: (event, value) => {
                props.handleFormikChange(`location`, value, 1)
            },
        },
        {
            name: 'category',
            type: 'select',
            title: 'Categories',
            search_type: 'checkbox',
            filter: true,
            item: category,
            onChange: (event, value) => {
                props.handleFormikChange(`category`, value, 1)
            },
        },
        {
            name: 'conditionTypeId',
            type: 'select',
            title: 'Condition',
            search_type: 'checkbox',
            filter: true,
            item: condition,
            onChange: (event, value) => {
                props.handleFormikChange(`conditionTypeId`, value, 1)
            },
        },
    ]

    return (
        <>
            {valueLoaded ? (
                <div className="filterPanel">
                    <div className="d-flex justify-content-center align-items-center filterTitleCnt">
                        <h4 className="fpTitle">
                            {props.filterName ? props.filterName : 'Filters'}
                        </h4>

                        {props.closeFilter && (
                            <Button
                                id="filters_close"
                                onClick={() => props.closeFilter()}
                                className="filterClose"
                            >
                                <span className="material-icons">cancel</span>
                            </Button>
                        )}
                    </div>

                    <div className="filterAcc">
                        <div className="filters-container">
                            {/* <Button className="searchdateRange">Search Date Range</Button> */}
                            {filterSections.map((data, index) => (
                                <Accordion
                                    square
                                    defaultExpanded
                                    key={index}
                                    onChange={handleChange(`panel${index}`)}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1d-content"
                                        id={`panel${index}d-header`}
                                    >
                                        <h6 className="accTitle" id={data.title}>
                                            {data.title}{' '}
                                            {props.filterCount &&
                                            formik.values?.filters[data?.name]?.value?.length ? (
                                                <span className="filterCount">
                                                    {
                                                        formik.values?.filters[data?.name]?.value
                                                            ?.length
                                                    }
                                                </span>
                                            ) : null}
                                        </h6>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {data.item && data.item.length > 0 ? (
                                            <div className="filterCheck d-flex align-items-center flex-wrap">
                                                {data.search_type === 'checkbox' &&
                                                data.type !== 'checkbox' &&
                                                data.name !== 'retrieval' ? (
                                                    data.item.map((d, i) => (
                                                        <>
                                                            <CheckBox
                                                                name={`filters.${data.name}.value`}
                                                                label={t(d.description)}
                                                                checked={
                                                                    formik?.values?.filters[
                                                                        data.name
                                                                    ]?.value?.indexOf(
                                                                        d.id.toString(),
                                                                    ) !== -1
                                                                        ? true
                                                                        : false
                                                                }
                                                                value={d.id.toString()}
                                                                // onChange={formik.handleChange}
                                                                onChange={(event, value) => {
                                                                    if (data.onChange) {
                                                                        const { name, value } =
                                                                            event.target
                                                                        const currentValues =
                                                                            formik?.values?.filters[
                                                                                data.name
                                                                            ]?.value || []
                                                                        const newValue =
                                                                            currentValues?.includes(
                                                                                value,
                                                                            )
                                                                                ? currentValues?.filter(
                                                                                      (v) =>
                                                                                          v !==
                                                                                          value,
                                                                                  )
                                                                                : [
                                                                                      ...currentValues,
                                                                                      value,
                                                                                  ].filter(
                                                                                      (v) =>
                                                                                          v !== '',
                                                                                  )
                                                                        data.onChange(
                                                                            event,
                                                                            newValue,
                                                                        )
                                                                    } else {
                                                                        formik?.handleChange()
                                                                    }
                                                                }}
                                                            />
                                                        </>
                                                    ))
                                                ) : data.search_type === 'checkbox' &&
                                                  data.type !== 'checkbox' &&
                                                  data.name === 'retrieval' ? (
                                                    data.item.map((d, i) => (
                                                        <>
                                                            <CheckBox
                                                                name={`filters.${d.show}.value`}
                                                                label={
                                                                    data.name === 'location'
                                                                        ? t(`${d.name}`)
                                                                        : t(
                                                                              capitalize(
                                                                                  d.description,
                                                                              ),
                                                                          )
                                                                }
                                                                checked={
                                                                    formik?.values?.filters[
                                                                        d.show
                                                                    ]?.value?.indexOf(
                                                                        d.id.toString(),
                                                                    ) !== -1
                                                                        ? true
                                                                        : false
                                                                }
                                                                value={d.id.toString()}
                                                                onChange={formik.handleChange}
                                                            />
                                                        </>
                                                    ))
                                                ) : data.search_type === 'checkbox' &&
                                                  data.type === 'checkbox' ? (
                                                    data.item.map((d, i) => (
                                                        <>
                                                            <CheckBox
                                                                name={`filters.${data.name}.value`}
                                                                label={
                                                                    data.name === 'location'
                                                                        ? t(`${d.name}`)
                                                                        : t(
                                                                              capitalize(
                                                                                  d.description,
                                                                              ),
                                                                          )
                                                                }
                                                                checked={
                                                                    formik?.values?.filters[
                                                                        data.name
                                                                    ].value.indexOf(
                                                                        d.id.toString(),
                                                                    ) !== -1
                                                                        ? true
                                                                        : false
                                                                }
                                                                value={d.id.toString()}
                                                                onChange={formik?.handleChange}
                                                            />
                                                        </>
                                                    ))
                                                ) : data.type === 'radio' && data.having !== 1 ? (
                                                    <>
                                                        <RadioBox
                                                            items={data.item}
                                                            value={
                                                                formik?.values?.filters[data.name]
                                                                    .value
                                                            }
                                                            onChange={formik.handleChange}
                                                            name={`filters.${data.name}.value`}
                                                            id={
                                                                formik?.values?.filters[data.name]
                                                                    ?.value
                                                            }
                                                            int={1}
                                                        />
                                                    </>
                                                ) : data.type === 'radio' && data.having === 1 ? (
                                                    <>
                                                        <RadioBox
                                                            items={data.item}
                                                            value={
                                                                formik.values.having[data.name]
                                                                    .value
                                                            }
                                                            id={
                                                                formik.values.having[data.name]
                                                                    .value
                                                            }
                                                            onChange={formik.handleChange}
                                                            name={`having.${data.name}.value`}
                                                            int={1}
                                                        />
                                                    </>
                                                ) : null}
                                            </div>
                                        ) : data.type === 'select' ? (
                                            <ul>
                                                {data?.options?.map((opt, idx) => (
                                                    <li
                                                        onClick={(event) => {
                                                            data.onChange(event, opt.value)
                                                        }}
                                                        key={idx}
                                                        className={`${
                                                            formik?.values[data.name] === opt.value
                                                                ? 'active'
                                                                : ''
                                                        }`}
                                                    >
                                                        {opt.show}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : data.type === 'number' && props.slider ? (
                                            <div className="priceInput">
                                                {props.priceLabel ? (
                                                    <h5>
                                                        {props.sliderText(
                                                            formik?.values?.filters?.min_price.value
                                                                ? formik?.values?.filters.min_price
                                                                      .value
                                                                : '0',
                                                        )}
                                                        <span> to </span>
                                                        {props.sliderText(
                                                            formik?.values?.filters?.max_price
                                                                ?.value
                                                                ? formik?.values?.filters?.max_price
                                                                      ?.value
                                                                : '0',
                                                        )}
                                                    </h5>
                                                ) : null}

                                                {props.priceFilter &&
                                                data.filter_type == 'price' ? (
                                                    <>
                                                        <Slider
                                                            getAriaLabel={() => 'Temperature range'}
                                                            value={priceRange}
                                                            onChange={handleChange1}
                                                            valueLabelDisplay="auto"
                                                            getAriaValueText={
                                                                props.sliderText
                                                                    ? props.sliderText
                                                                    : sliderText
                                                            }
                                                            max={
                                                                props.max_price
                                                                    ? props.max_price
                                                                    : 10000
                                                            }
                                                            id="slider_price"
                                                        />
                                                        <div className="row">
                                                            {mapData(props.priceFilter)}
                                                        </div>
                                                    </>
                                                ) : null}
                                                {props.kilometerFilter &&
                                                data.filter_type == 'kilometer' ? (
                                                    <>
                                                        <Slider
                                                            getAriaLabel={() => 'Temperature range'}
                                                            value={kilometerRange}
                                                            onChange={handleChange2}
                                                            valueLabelDisplay="auto"
                                                            getAriaValueText={sliderText}
                                                            max={500000}
                                                            id="slider_kilometer"
                                                        />
                                                        <div className="row">
                                                            {mapData(props.kilometerFilter)}
                                                        </div>
                                                    </>
                                                ) : null}
                                                {props.powerFilter &&
                                                data.filter_type == 'power' ? (
                                                    <>
                                                        <Slider
                                                            getAriaLabel={() => 'Temperature range'}
                                                            value={powerRange}
                                                            onChange={handleChange3}
                                                            valueLabelDisplay="auto"
                                                            getAriaValueText={sliderText}
                                                            max={500}
                                                            id="slider_power"
                                                        />
                                                        <div className="row">
                                                            {mapData(props.powerFilter)}
                                                        </div>
                                                    </>
                                                ) : null}
                                                {props.yearFilter && data.filter_type == 'year' ? (
                                                    <>
                                                        <Slider
                                                            getAriaLabel={() => 'Temperature range'}
                                                            value={yearRange}
                                                            onChange={handleChangeYear}
                                                            valueLabelDisplay="auto"
                                                            getAriaValueText={sliderText}
                                                            max={2100}
                                                            id="slider_year"
                                                        />
                                                        <div className="row">
                                                            {mapData(props.yearFilter)}
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div>
                                        ) : (
                                            <small>{t(`${'No'} ${data.title} ${'Found'}`)}</small>
                                        )}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </div>
                    </div>
                    {props.clearSearch &&
                        (props.hideClearBtn ? (
                            showBtn ? (
                                <Button
                                    id="filters_clear"
                                    onClick={() => props.clearSearch()}
                                    className="filterClear ml-auto"
                                >
                                    {!props.closeFilter && (
                                        <span className="material-icons">cancel</span>
                                    )}
                                    {props.clearAll ? props.clearAll : 'Clear all'}
                                </Button>
                            ) : null
                        ) : (
                            <Button
                                id="filters_clear"
                                onClick={() => props.clearSearch()}
                                className="filterClear ml-auto"
                            >
                                {props.clearAll ? props.clearAll : 'Clear all'}
                            </Button>
                        ))}
                </div>
            ) : null}
        </>
    )
}
export default FilterPanel
